import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const TuerenFenster = () => {
  const pageData = {
    title: 'TÜREN & FENSTER',
    subtitle: 'Montage & Rollläden',
    description: 'Professionelle Montage von Türen, Fenstern und Rollläden. Wir sorgen für perfekte Passform, optimale Dämmung und einwandfreie Funktion.',
    heroImage: 'https://images.unsplash.com/photo-1717997695609-a0a5a515991d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3aW5kb3clMjBpbnN0YWxsYXRpb24lMjBob3VzZSUyMHJlbm92YXRpb24lMjBkb29yfGVufDB8fHx8MTc3NzY0MzE5MHww&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Innentüren', description: 'Montage von Zimmertüren aller Art und Materialien.' },
      { title: 'Haustüren', description: 'Sichere und energieeffiziente Eingangstüren.' },
      { title: 'Fenster', description: 'Kunststoff-, Holz- und Aluminium-Fenster.' },
      { title: 'Rollläden', description: 'Manuelle und elektrische Rollladensysteme.' },
      { title: 'Sonnenschutz', description: 'Markisen, Raffstoren und Jalousien.' },
      { title: 'Reparaturen', description: 'Wartung und Reparatur bestehender Elemente.' }
    ],
    benefits: [
      'Präzise Montage für optimale Funktion',
      'Fachgerechte Abdichtung und Dämmung',
      'Zusammenarbeit mit Top-Herstellern',
      'Beratung zu Sicherheit und Energieeffizienz',
      'Entsorgung alter Elemente inklusive',
      'Garantie auf alle Montagearbeiten'
    ],
    process: [
      { title: 'Aufmass', description: 'Präzises Vermessen vor Ort.' },
      { title: 'Demontage', description: 'Fachgerechter Ausbau alter Elemente.' },
      { title: 'Montage', description: 'Einbau mit optimaler Abdichtung.' },
      { title: 'Abnahme', description: 'Funktionsprüfung und Einweisung.' }
    ],
    gallery: [
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/anpdmeaz_WhatsApp%20Image%202026-05-01%20at%2010.45.53%20%282%29.jpeg',
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/5dlwddz3_WhatsApp%20Image%202026-05-01%20at%2010.45.53%20%283%29.jpeg'
    ],
    metaKeywords: 'Türen montieren Graubünden, Fenster einbauen Cazis, Rollläden Schweiz'
  };

  return <ServiceTemplate {...pageData} />;
};

export default TuerenFenster;
